module.exports = __webpack_public_path__ + "img/drake.3055caad.jpeg";